<template>
  <div
    id="tags-view-container"
    :class="['tags-view-container', { 'has-scroll': scrollableLeft || scrollableRight }]"
    :style="tagBarStyle"
  >
    <!-- 左侧箭头按钮 -->
    <div class="tags-view-container-arrow">
      <span v-show="scrollableLeft" class="arrow left" @click="scrollLeft">
        <i class="el-icon-arrow-left"></i>
      </span>
      <scroll-pane ref="scrollPane" class="tags-view-wrapper" @scroll="handleScroll">
        <router-link
          v-for="tag in visitedViews"
          ref="tag"
          :key="tag.path"
          :class="isActive(tag) ? 'active' : ''"
          :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
          tag="span"
          class="tags-view-item"
          @click.middle.native="!isAffix(tag) ? closeSelectedTag(tag) : ''"
          @contextmenu.prevent.native="openMenu(tag, $event)"
        >
          {{ tag.title }}
          <span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
        </router-link>
      </scroll-pane>
      <!-- 右侧箭头按钮 -->
      <span v-show="scrollableRight" class="arrow right" @click="scrollRight">
        <i class="el-icon-arrow-right"></i>
      </span>
    </div>
    <ul v-show="visible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
      <!-- <li @click="refreshSelectedTag(selectedTag)"><i class="el-icon-refresh-right"></i> 刷新页面</li> -->
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">
        <i class="el-icon-close"></i> 关闭当前
      </li>
      <li @click="closeOthersTags"><i class="el-icon-circle-close"></i> 关闭其他</li>
      <!-- <li v-if="!isFirstView()" @click="closeLeftTags"><i class="el-icon-back"></i> 关闭左侧</li>
      <li v-if="!isLastView()" @click="closeRightTags"><i class="el-icon-right"></i> 关闭右侧</li> -->
      <li @click="closeAllTags(selectedTag)"><i class="el-icon-circle-close"></i> 全部关闭</li>
    </ul>
  </div>
</template>

<script>
import ScrollPane from './ScrollPane'
// import path from 'path'

export default {
  components: { ScrollPane },
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: [],
      scrollableLeft: false,
      scrollableRight: false,
    }
  },
  computed: {
    tagBarStyle() {
      return {
        left: this.isMobile ? '0' : this.collapsed ? '80px' : '256px',
      }
    },
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    routes() {
      return this.$store.state.permission.routes
    },
    // theme() {
    //   return this.$store.state.settings.theme
    // },
  },
  watch: {
    $route() {
      this.addTags()
      this.moveToCurrentTag()
    },
    collapsed() {
      this.$nextTick(this.checkScrollable)
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    },
  },
  mounted() {
    this.addTags()
    this.initTags()
    this.$nextTick(this.checkScrollable)
    window.addEventListener('resize', this.checkScrollable)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScrollable)
  },
  methods: {
    // 检查是否需要显示滚动箭头
    checkScrollable() {
      const scrollWrapper = this.$refs.scrollPane?.$refs.scrollContainer?.$refs.wrap
      if (!scrollWrapper) return

      this.scrollableLeft = scrollWrapper.scrollLeft > 0
      this.scrollableRight = scrollWrapper.scrollLeft + scrollWrapper.clientWidth < scrollWrapper.scrollWidth - 1 // 减去1避免精度问题
    },

    // 左滚动
    scrollLeft() {
      const scrollWrapper = this.$refs.scrollPane?.$refs.scrollContainer?.$refs.wrap
      if (scrollWrapper) {
        scrollWrapper.scrollLeft -= 200
        this.$nextTick(() => this.checkScrollable())
      }
    },

    // 右滚动
    scrollRight() {
      const scrollWrapper = this.$refs.scrollPane?.$refs.scrollContainer?.$refs.wrap
      if (scrollWrapper) {
        scrollWrapper.scrollLeft += 200
        this.$nextTick(() => this.checkScrollable())
      }
    },

    // 在滚动事件处理中更新箭头状态
    handleScroll() {
      this.closeMenu()
      this.$nextTick(() => this.checkScrollable())
    },
    isActive(route) {
      return route.path === this.$route.path
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix
    },
    isFirstView() {
      try {
        return this.selectedTag.fullPath === this.visitedViews[1].fullPath || this.selectedTag.fullPath === '/index'
      } catch (err) {
        return false
      }
    },
    isLastView() {
      try {
        return this.selectedTag.fullPath === this.visitedViews[this.visitedViews.length - 1].fullPath
      } catch (err) {
        return false
      }
    },
    filterAffixTags(routes, basePath = '/') {
      let tags = []
      routes?.forEach((route) => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta },
          })
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    },
    initTags() {
      const affixTags = (this.affixTags = this.filterAffixTags(this.routes))
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', tag)
        }
      }
    },
    addTags() {
      const { name } = this.$route
      if (name) {
        this.$store.dispatch('tagsView/addView', this.$route)
        if (this.$route.meta.link) {
          this.$store.dispatch('tagsView/addIframeView', this.$route)
        }
      }
      return false
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag)
            // when query is different then update
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch('tagsView/updateVisitedView', this.$route)
            }
            break
          }
        }
      })
    },
    refreshSelectedTag(view) {
      this.$tab.refreshPage(view)
      if (this.$route.meta.link) {
        this.$store.dispatch('tagsView/delIframeView', this.$route)
      }
    },
    closeSelectedTag(view) {
      this.$tab.closePage(view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },
    closeRightTags() {
      this.$tab.closeRightPage(this.selectedTag).then((visitedViews) => {
        if (!visitedViews.find((i) => i.fullPath === this.$route.fullPath)) {
          this.toLastView(visitedViews)
        }
      })
    },
    closeLeftTags() {
      this.$tab.closeLeftPage(this.selectedTag).then((visitedViews) => {
        if (!visitedViews.find((i) => i.fullPath === this.$route.fullPath)) {
          this.toLastView(visitedViews)
        }
      })
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag).catch(() => {})
      this.$tab.closeOtherPage(this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    closeAllTags(view) {
      this.$tab.closeAllPage().then(({ visitedViews }) => {
        if (this.affixTags.some((tag) => tag.path === this.$route.path)) {
          return
        }
        this.toLastView(visitedViews, view)
      })
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.fullPath)
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({ path: '/redirect' + view.fullPath })
        } else {
          this.$router.push('/')
        }
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 10 // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }

      this.top = e.clientY - this.$el.getBoundingClientRect().top + 8
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep body,
::v-deep .tags-view-container,
::v-deep .tags-view-wrapper,
::v-deep .tags-view-container-arrow {
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }
}

.tags-view-container {
  position: fixed;
  top: 56px;
  right: 0;
  z-index: 90;
  width: auto;
  height: 44px;
  padding: 0 12px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid #e9edf3;
  box-shadow: 0 4px 13px rgba(24, 34, 48, 0.045);
  backdrop-filter: blur(12px);
  transition: left 0.2s ease;

  &.has-scroll {
    padding-right: 38px;
    padding-left: 38px;
  }

  .arrow {
    position: absolute;
    top: 50%;
    z-index: 4;
    width: 26px;
    height: 26px;
    color: #7b8494;
    line-height: 26px;
    text-align: center;
    background: #f6f7f9;
    border: 1px solid #edf0f4;
    border-radius: 8px;
    cursor: pointer;
    transform: translateY(-50%);
    transition: 0.2s ease;

    &:hover {
      color: #315efb;
      background: #eef2ff;
      border-color: #dce4ff;
    }

    &.left {
      left: 7px;
    }

    &.right {
      right: 7px;
    }

    i {
      font-size: 12px;
      font-weight: 600;
    }
  }

  .tags-view-wrapper {
    .tags-view-item {
      position: relative;
      display: inline-block;
      height: 30px;
      margin-top: 7px;
      margin-left: 6px;
      padding: 0 11px;
      color: #667085;
      font-size: 12px;
      line-height: 28px;
      background: #f7f8fa;
      border: 1px solid transparent;
      border-radius: 8px;
      cursor: pointer;
      transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease;

      &:first-of-type {
        margin-left: 0;
      }

      &:last-of-type {
        margin-right: 6px;
      }

      &:hover {
        color: #315efb;
        background: #f1f4ff;
      }

      &.active {
        color: #315efb;
        font-weight: 500;
        background: #eef2ff;
        border-color: #dce4ff;

        &::before {
          position: relative;
          display: inline-block;
          width: 5px;
          height: 5px;
          margin-right: 6px;
          vertical-align: 1px;
          background: #315efb;
          border-radius: 50%;
          box-shadow: 0 0 0 3px rgba(49, 94, 251, 0.1);
          content: '';
        }
      }
    }
  }
  .contextmenu {
    position: absolute;
    z-index: 3000;
    margin: 0;
    padding: 6px;
    color: #344054;
    font-weight: 400;
    font-size: 12px;
    list-style-type: none;
    background: #fff;
    border: 1px solid #eaecf0;
    border-radius: 9px;
    box-shadow: 0 12px 30px rgba(16, 24, 40, 0.14);

    li {
      margin: 0;
      padding: 7px 11px;
      border-radius: 6px;
      cursor: pointer;

      i {
        margin-right: 6px;
        color: #98a2b3;
      }

      &:hover {
        color: #315efb;
        background: #f2f4ff;
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .tags-view-container {
    top: 56px;
    left: 0 !important;
  }
}
</style>

<style lang="less">
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      width: 16px;
      height: 16px;
      text-align: center;
      vertical-align: 2px;
      border-radius: 50%;
      transform-origin: 100% 50%;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      &:before {
        display: inline-block;
        vertical-align: -3px;
        transform: scale(0.6);
      }
      &:hover {
        color: #315efb;
        background-color: #dce4ff;
      }
    }
  }
}
</style>
